import { removeSpacesFromString } from '../../utils';

const requestBodyTemplate: api.AmendAppointmentModel = {
  ActivationDate: null,
  ActivationSlot: null,
  AlternateSiteContact: null,
  Appointment: null,
  AppointmentDate: null,
  AppointmentSlot: null,
  EngineeringNotes: null,
  EngineeringNotes2: null,
  IsASCChanged: false,
  IsActivationDateChanged: false,
  IsAppointmentChanged: false,
  IsLegacy: false,
  IsSiteContactChanged: false,
  PcpOnly: false,
  ItemReference: null,
  MoveInDate: null,
  MoveInSlot: null,
  MoveOutDate: null,
  PONRServicePointStatus: null,
  PONRServicePointSubStatus: null,
  PostCode: null,
  SiteContact: null,
  TrackedOrderKey: null,
  UserName: null,
};

const getAABodyPartForChangingDate = ({
  date,
  slot,
}: api.AmendAppointmentData): Partial<api.AmendAppointmentModel> => ({
  Appointment: {
    AddressKey: null,
    AppointmentBook: null,
    AppointmentDate: date,
    AppointmentSlot: slot,
    DBIDValue: null,
  },
  AppointmentDate: date,
  AppointmentSlot: slot,
  IsAppointmentChanged: true,
});

const getAABodyPartForChangingSiteContact = ({
  contact: { contactKey, email, title, firstName, lastName, phone, additionalPhoneNumber },
}: api.AmendAppointmentData): Partial<api.AmendAppointmentModel> => ({
  IsSiteContactChanged: true,
  SiteContact: {
    ContactContext: null,
    ContactKey: contactKey.startsWith('new') ? null : contactKey,
    Email: email,
    Extension: null,
    FirstName: firstName,
    HomePhone: removeSpacesFromString(additionalPhoneNumber) || null,
    LastName: lastName,
    Mobile: removeSpacesFromString(phone) || null,
    PreferredContact: null,
    Title: title,
    WorkPhone: null,
  },
});

export const getAmendAppointmentRequestBody = (
  amendAppointmentData: api.AmendAppointmentData,
  isDateChanged: boolean,
  isSiteContactChanged: boolean,
): api.AmendAppointmentModel => {
  const {
    itemId,
    orderKey,
    postcode,
    contact: { fullName },
  } = amendAppointmentData;

  return {
    ...requestBodyTemplate,
    ItemReference: itemId,
    PostCode: postcode,
    TrackedOrderKey: orderKey,
    UserName: fullName,
    ...(isSiteContactChanged ? getAABodyPartForChangingSiteContact(amendAppointmentData) : {}),
    ...(isDateChanged ? getAABodyPartForChangingDate(amendAppointmentData) : {}),
  };
};
